var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectDetail1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 500,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg7",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#1a237e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#3949ab",
      stopOpacity: 1
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 500,
    fill: "url(#bg7)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50, 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 700,
    height: 400,
    rx: 10,
    fill: "#ffffff",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("text", {
    x: 350,
    y: 50,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fontWeight: "bold",
    fill: "#1a237e"
  }, "Project Detail - View 1"), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 100,
    width: 600,
    height: 250,
    fill: "#e8eaf6",
    rx: 5
  }), /*#__PURE__*/React.createElement("text", {
    x: 350,
    y: 225,
    textAnchor: "middle",
    fontFamily: "Arial",
    fontSize: 18,
    fill: "#1a237e"
  }, "Screenshot or Feature"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectDetail1);
export default __webpack_public_path__ + "static/media/project-detail-1.de0cecbabbca86c29ca83a711cec8275.svg";
export { ForwardRef as ReactComponent };